class ErrCustom extends Error {
  get messageToStore () {
    return this.message
  }
}

export { ErrCustom }
